import { D as DialogComponent } from "./dialog-ClmwiceK.js";
import { T as ThemeEvents } from "./events-C4hlH4zR.js";
import { d as defineCustomElement, f as formatMoney } from "./utilities-DuXQiAqj.js";
import "./component-DqhvLgtR.js";
class CartDrawerComponent extends DialogComponent {
  #removingBtn = null;
  #pointerDownTimeout = null;
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("liquid-ajax-cart:request-start", this.#handleRequestStart, {
      signal: this.signal,
    });
    document.addEventListener("pointerdown", this.#handlePointerDown, {
      signal: this.signal,
    });
    document.addEventListener("liquid-ajax-cart:request-end", this.#handleRequestEnd, {
      signal: this.signal,
    });
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate, {
      signal: this.signal,
    });
    if (window.liquidAjaxCart?.cart) {
      this.#updateShippingDisplay();
    } else {
      const initHandler = () => {
        this.#updateShippingDisplay();
        document.removeEventListener("liquid-ajax-cart:init", initHandler);
      };
      document.addEventListener("liquid-ajax-cart:init", initHandler, { signal: this.signal });
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  #handlePointerDown = (event) => {
    const btn = event.target.closest("[data-ajax-cart-request-button]");
    if (!btn) {
      return;
    }
    if (this.#pointerDownTimeout) {
      clearTimeout(this.#pointerDownTimeout);
    }
    this.#removingBtn = btn;
    btn.classList.add("is-removing-pending");
    this.#pointerDownTimeout = setTimeout(() => {
      if (this.#removingBtn === btn) {
        btn.classList.remove("is-removing-pending");
        this.#removingBtn = null;
      }
    }, 500);
  };
  #handleRequestStart = (event) => {
    const { requestState } = event.detail;
    if (this.#pointerDownTimeout) {
      clearTimeout(this.#pointerDownTimeout);
      this.#pointerDownTimeout = null;
    }
    const initiator = requestState.info?.initiator;
    if (initiator?.hasAttribute("data-ajax-cart-request-button")) {
      this.#removingBtn = initiator;
      initiator.classList.remove("is-removing-pending");
      initiator.classList.add("is-removing");
    } else if (this.#removingBtn) {
      this.#removingBtn.classList.remove("is-removing-pending");
      this.#removingBtn.classList.add("is-removing");
    }
    if (requestState.requestType !== "add") {
      return;
    }
    const itemCount = window.liquidAjaxCart?.cart?.item_count ?? 0;
    if (itemCount > 0) {
      if (!this.open) {
        this.showDialog();
      }
      this.dataset.loading = "";
    }
  };
  #handleRequestEnd = (event) => {
    const { requestState } = event.detail;
    if (this.#removingBtn) {
      this.#removingBtn.classList.remove("is-removing", "is-removing-pending");
      this.#removingBtn = null;
    }
    if (requestState.requestType !== "add") {
      return;
    }
    delete this.dataset.loading;
    if (!requestState.responseData?.ok) {
      return;
    }
    if (!this.open) {
      this.showDialog();
    }
  };
  #handleCartUpdate = (event) => {
    const cart = event.detail?.resource;
    this.#updateShippingDisplay(cart);
    this.#syncStaticFooter(cart);
  };
  #syncStaticFooter(cart) {
    const isEmpty = (cart?.item_count ?? 0) === 0;
    for (const el of this.querySelectorAll(
      "[data-cart-static-footer], [data-cart-static-upsells]"
    )) {
      if (!isEmpty && el.dataset.upsellsEmpty === "true") {
        continue;
      }
      el.hidden = isEmpty;
    }
  }
  /**
   * Updates the shipping cost display based on cart total and threshold.
   *
   * @param {Object} [cart] - Optional cart object from event, otherwise uses liquidAjaxCart
   */
  #updateShippingDisplay(cart) {
    const shippingElement = this.querySelector(".js-shipping-cost");
    if (!shippingElement) {
      return;
    }
    const threshold = parseInt(shippingElement.dataset.threshold) || 5e3;
    const standardCost = parseInt(shippingElement.dataset.standardCost) || 495;
    let currentTotal = 0;
    if (typeof cart?.total_price === "number") {
      currentTotal = cart.total_price;
    } else if (typeof window.liquidAjaxCart?.cart?.total_price === "number") {
      currentTotal = window.liquidAjaxCart.cart.total_price;
    }
    const locale = this.dataset.locale || "de-DE";
    const currency = this.dataset.currency || "EUR";
    const isFree = currentTotal >= threshold;
    if (isFree) {
      const freeText = shippingElement.dataset.freeShippingText || "Free shipping";
      const span = document.createElement("span");
      span.className = "text-success font-semibold";
      span.textContent = freeText;
      shippingElement.replaceChildren(span);
    } else {
      const costSpan = document.createElement("span");
      costSpan.textContent = formatMoney(standardCost, { locale, currency });
      shippingElement.replaceChildren(costSpan);
    }
    const totalElement = this.querySelector(".js-cart-total");
    if (totalElement) {
      const summe = currentTotal + (isFree ? 0 : standardCost);
      totalElement.textContent = formatMoney(summe, { locale, currency });
    }
  }
}
defineCustomElement("cart-drawer-component", CartDrawerComponent);
